const form = {
  formId: "oil-gas-01",
  formField: {
    checkbox1: {
      name: "checkbox1",
      label: "[01] Dầu thô",
      type: "text",
    },
    checkbox2: {
      name: "checkbox2",
      label: "[02] Condensate",
      type: "text",
    },
    checkbox3: {
      name: "checkbox3",
      label: "[03] Khí thiên nhiên",
      type: "text",
    },
    taxCalculationPeriod: {
      name: "taxCalculationPeriod",
      label: "[04] Kỳ tính thuế:",
      type: "number",
      placeholder: "01/2023",
      errorMsg: "Vui lòng chọn kỳ tính thuế",
    },
    releaseTime: {
      name: "releaseTime",
      label: "[05] Lần xuất bản thứ",
      type: "number",
      errorMsg: "Vui lòng nhập",
    },
    firstTime: {
      name: "firstTime",
      label: "[06] Lần đầu:",
      type: "text",
    },
    supplementaryForThe: {
      name: "supplementaryForThe",
      label: "[07] Bổ sung lần thứ:",
      type: "number",
      placeholder: "Chọn",
      errorMsg: "Vui lòng nhập bổ sung lần thứ",
      invalidMsg: "Số không hợp lệ",
    },
    isExport: {
      name: "isExport",
      label: "[08] Xuất khẩu",
      type: "text",
    },
    releaseInVietNam: {
      name: "releaseInVietNam",
      label: "[09] Xuất bán tại Việt Nam",
      type: "text",
    },
    billExportDate: {
      name: "billExportDate",
      label: "[10] Ngày xuất hóa đơn đối với xuất bản tại Việt Nam",
      type: "number",
      placeholder: "",
      errorMsg: "Vui lòng chọn ngày ký",
    },
    taxpayerName: {
      name: "taxpayerName",
      label: "[11] Tên người nộp thuế",
      type: "text",
      errorMsg: "Vui lòng nhập tên người nộp thuế",
    },
    taxId: {
      name: "taxId",
      label: "[12] Mã số thuế:",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng nhập mã số thuế",
      invalidMsg: "Mã số thuế không hợp lệ",
    },
    contract: {
      name: "contract",
      label: "[19] Hợp đồng dầu khí lô",
      type: "text",
      placeholder: "Chọn",
      errorMsg: "Vui lòng nhập mã hợp đồng",
    },
    checkbox4: {
      name: "checkbox4",
      label: "[20] Tên đơn vị được ủy quyền",
      type: "text",
    },
    checkbox5: {
      name: "checkbox5",
      label: "Hoặc đại lý thuế",
      type: "text",
    },
    taxId2: {
      name: "taxId2",
      label: "[21] Mã số thuế:",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng nhập mã số thuế",
      invalidMsg: "Mã số thuế không hợp lệ",
    },
    moneyType: {
      name: "moneyType",
      label: "Loại đơn vị tiền",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng chọn",
    },

    fullName: {
      name: "fullName",
      label: "Họ và tên",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng họ và tên",
    },
    certificate: {
      name: "certificate",
      label: "Chứng chỉ hành nghề số:",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng nhập chứng chỉ hành nghề số",
    },
    signer: {
      name: "signer",
      label: "Người ký",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng nhập người ký",
    },
    timeSign: {
      name: "timeSign",
      label: "Ngày ký",
      type: "number",
      placeholder: "",
      errorMsg: "Vui lòng chọn ngày ký",
    },
  },
};

export default form;
